import { useState, useMemo, PropsWithChildren } from 'react';

import { useTranslation } from 'react-i18next';
import { Button } from '@kizen/kds/Button';

import SelectOverlay from '__components/Inputs/SelectOverlay';
import { SelectNoScrollCapture as Select } from '__components/Inputs/Select';

import { ContinueWithBranch } from './types';

import { GenericOption } from 'pages/AutomationEngine/types';

type PathSelectButtonProps = PropsWithChildren<{
  disabled: boolean;
  onClick: (option: ContinueWithBranch) => void;
  isGoal: boolean;
}>;

export const PathSelectButton = ({
  children,
  onClick,
  disabled,
  isGoal,
}: PathSelectButtonProps) => {
  const { t } = useTranslation();
  const [selectedAction, setSelectedAction] = useState<GenericOption | null>(
    null
  );

  const options: GenericOption<ContinueWithBranch>[] = useMemo(
    () =>
      isGoal
        ? [
            { value: 'yes', label: 'Met Path' },
            { value: 'no', label: 'Not Met Path' },
          ]
        : [
            { value: 'yes', label: 'Yes Path' },
            { value: 'no', label: 'No Path' },
          ],
    [isGoal]
  );

  return (
    <Button
      leftIcon="text-redo"
      variant="text"
      actions
      size="small"
      allowEmptyActions
      qa={{
        action: 'action-skip',
        type: 'icon-button',
      }}
      preserveCase
      maxWidth={false}
      color="secondary"
      disabled={!!disabled}
      dropdown={({ trigger, isShowing, onChange, onHide }) => {
        if (!isShowing && selectedAction) {
          setSelectedAction(null);
        }

        return (
          <SelectOverlay
            show={isShowing}
            target={trigger?.current}
            onHide={onHide}
            style={{ width: '141px' }}
          >
            <Select
              dataQa="skip-path-menu"
              menuOnly
              options={options}
              onChange={({ value }: GenericOption<ContinueWithBranch>) => {
                onHide();
                onClick(value);
              }}
              value={selectedAction}
              placeholder={t('Choose Action')}
              classNamePrefix="automation-select"
            />
          </SelectOverlay>
        );
      }}
    >
      {children}
    </Button>
  );
};
